import { render } from "./AddAsset.vue?vue&type=template&id=1b5a19c2&ts=true"
import script from "./AddAsset.vue?vue&type=script&lang=ts"
export * from "./AddAsset.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__